import { ChangeDetectionStrategy, Component, output } from '@angular/core';

/** Round close button shared by the full-screen popups; position it inside a `fixed`/`relative` overlay. */
@Component({
  selector: 'app-popup-close',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      class="absolute top-4 right-4 flex items-center justify-center size-12 rounded-full border-3 border-transparent bg-transparent text-black cursor-pointer hover:border-black hover:bg-transparent"
      (click)="closed.emit()"
      aria-label="Close"
    >
      <svg class="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>
    </button>
  `,
})
export class PopupCloseComponent {
  closed = output();
}
